import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { FC, useContext } from 'react';

import { Application } from '@features/applications';
import MessagingForm from '@features/messaging/components/MessagingForm/MessagingForm';
import { authContext } from '@staffedupusa/shared-components';
import EnterpriseMessagingForm from '../EnterpriseMessagingForm/EnterpriseMessagingForm';
import CloseIcon from '@mui/icons-material/Close';
import { DateIcon, MessageIcon } from '../../../../vectors/index';

type MessagingModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  application: Application;
  handlePageNo?: (newPageNo: number) => void;
};

const MessagingModal: FC<MessagingModalProps> = ({
  isOpen,
  handleClose,
  application,
  handlePageNo
}) => {
  const { authData } = useContext(authContext);
  const isApplicant =
    authData?.user &&
    !authData?.user?.company &&
    !authData?.user.enterprise &&
    !authData?.user.is_admin &&
    !authData?.user.is_rockerbox;
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      disableEnforceFocus
    >
      <DialogContent>
        {authData.user?.enterprise ? (
          <EnterpriseMessagingForm
            application={application}
            applicantId={application.applicant?.id}
            onUnreadSuccess={handleClose}
            companyId={application.job_listing?.company.id}
            showMarkReadButton={true}
            handlePageNo={handlePageNo}
          />
        ) : (
          <MessagingForm
            application={application}
            onUnreadSuccess={handleClose}
            isApplicant={isApplicant}
            showMarkReadButton={true}
            handlePageNo={handlePageNo}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default MessagingModal;
